export interface Category {
  id: string;
  nameKey: string;
  url: string;
  imageUrl: string;
}

export const categories: Category[] = [
  {
    id: 'shoes',
    nameKey: 'cat_shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=White%20minimalist%20sneaker%20pair%20on%20light%20grey%20concrete%20studio%20floor%20top%20down%20angle%20clean%20product%20photography%20bright%20natural%20daylight%20simple%20editorial%20style%20high%20detail%20no%20people&width=600&height=600&seq=cat-shoes-02&orientation=squarish',
  },
  {
    id: 'hoodies',
    nameKey: 'cat_hoodies',
    url: 'https://kaspreadsheet.com/search-912/name/Hoodies.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Heather%20grey%20oversized%20hoodie%20on%20wooden%20hanger%20against%20soft%20sage%20green%20wall%20cozy%20streetwear%20product%20photo%20soft%20natural%20light%20minimal%20styling%20no%20people&width=600&height=600&seq=cat-hoodies-02&orientation=squarish',
  },
  {
    id: 'tshirts',
    nameKey: 'cat_tshirts',
    url: 'https://kaspreadsheet.com/search-913/name/T-Shirts.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Stack%20of%20folded%20pastel%20cotton%20t-shirts%20in%20teal%20coral%20and%20cream%20on%20light%20linen%20surface%20overhead%20flat%20lay%20soft%20shadows%20clean%20fashion%20photography%20no%20people&width=600&height=600&seq=cat-tshirts-02&orientation=squarish',
  },
  {
    id: 'jackets',
    nameKey: 'cat_jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Jackets.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Black%20leather%20biker%20jacket%20on%20mannequin%20torso%20against%20warm%20terracotta%20studio%20backdrop%20moody%20editorial%20product%20photography%20soft%20rim%20lighting%20no%20people&width=600&height=600&seq=cat-jackets-02&orientation=squarish',
  },
  {
    id: 'pants',
    nameKey: 'cat_pants',
    url: 'https://kaspreadsheet.com/search-915/name/Pants.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Blue%20denim%20jeans%20folded%20neatly%20on%20rustic%20light%20wood%20table%20casual%20fashion%20product%20photography%20bright%20soft%20daylight%20minimal%20clean%20composition%20no%20people&width=600&height=600&seq=cat-pants-02&orientation=squarish',
  },
  {
    id: 'headwear',
    nameKey: 'cat_headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Headwear.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Red%20baseball%20cap%20with%20curved%20brim%20on%20white%20pedestal%20studio%20product%20photography%20soft%20diffused%20lighting%20minimal%20bright%20background%20no%20people&width=600&height=600&seq=cat-headwear-02&orientation=squarish',
  },
  {
    id: 'sets',
    nameKey: 'cat_sets',
    url: 'https://kaspreadsheet.com/search-917/name/Sets.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Matching%20beige%20sweatshirt%20and%20jogger%20tracksuit%20set%20displayed%20on%20a%20clothing%20rack%20neutral%20warm%20studio%20soft%20editorial%20fashion%20photography%20no%20people&width=600&height=600&seq=cat-sets-02&orientation=squarish',
  },
  {
    id: 'underwear',
    nameKey: 'cat_underwear',
    url: 'https://kaspreadsheet.com/search-918/name/Underwear.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cotton%20boxer%20briefs%20in%20navy%20and%20grey%20neatly%20folded%20on%20soft%20white%20towel%20clean%20minimal%20product%20photography%20soft%20natural%20light%20no%20people&width=600&height=600&seq=cat-underwear-02&orientation=squarish',
  },
  {
    id: 'jersey',
    nameKey: 'cat_jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Jersey.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Emerald%20green%20football%20jersey%20with%20white%20trim%20on%20hanger%20against%20light%20studio%20background%20sportswear%20product%20photography%20crisp%20detail%20no%20people&width=600&height=600&seq=cat-jersey-02&orientation=squarish',
  },
  {
    id: 'accessories',
    nameKey: 'cat_accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Accessories.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Gold%20wristwatch%20and%20aviator%20sunglasses%20arranged%20on%20cream%20marble%20surface%20luxury%20accessory%20flat%20lay%20soft%20warm%20lighting%20editorial%20style%20no%20people&width=600&height=600&seq=cat-accessories-02&orientation=squarish',
  },
  {
    id: 'bags',
    nameKey: 'cat_bags',
    url: 'https://kaspreadsheet.com/search-921/name/Bags.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Tan%20leather%20backpack%20and%20canvas%20tote%20bag%20leaning%20against%20light%20beige%20wall%20minimal%20fashion%20product%20photography%20soft%20natural%20window%20light%20no%20people&width=600&height=600&seq=cat-bags-02&orientation=squarish',
  },
  {
    id: 'belts',
    nameKey: 'cat_belts',
    url: 'https://kaspreadsheet.com/search-922/name/Belts.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Rolled%20brown%20leather%20belts%20with%20brass%20buckles%20on%20warm%20oak%20wood%20surface%20accessory%20product%20photography%20soft%20warm%20light%20minimal%20composition%20no%20people&width=600&height=600&seq=cat-belts-02&orientation=squarish',
  },
  {
    id: 'perfumes',
    nameKey: 'cat_perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Perfumes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Crystal%20glass%20perfume%20bottle%20with%20amber%20liquid%20on%20reflective%20surface%20luxury%20beauty%20product%20photography%20soft%20studio%20lighting%20elegant%20minimal%20background%20no%20people&width=600&height=600&seq=cat-perfumes-02&orientation=squarish',
  },
  {
    id: 'other',
    nameKey: 'cat_other',
    url: 'https://kaspreadsheet.com/search-924/name/Other.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Curated%20assortment%20of%20fashion%20accessories%20including%20knitted%20scarf%20beanie%20and%20socks%20on%20light%20neutral%20background%20editorial%20flat%20lay%20soft%20natural%20light%20no%20people&width=600&height=600&seq=cat-other-02&orientation=squarish',
  },
];